import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Guard funcional para verificar autenticação
 * 
 * Se o usuário não estiver autenticado:
 * - Salva URL de retorno no sessionStorage
 * - Redireciona para login no Keycloak
 */
export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  
  if (authService.isAuthenticated()) {
    return true;
  }
  
  // Salva URL de retorno para redirecionar após login
  sessionStorage.setItem('auth_return_url', state.url);
  
  // Inicia fluxo de autenticação
  authService.login();
  
  return false;
};

